// Favoritos sem app, no molde do Minimog: a lista de handles vive no
// localStorage do navegador. O coração dos cards ([data-wishlist-toggle])
// entra e tira da lista, o contador do cabeçalho ([data-wishlist-count])
// acompanha, e a página de favoritos (<wishlist-page>) busca o card de
// cada produto pelo template alternativo product.card e monta a grade.
//
// Sem servidor no meio: a lista é do aparelho, como no Minimog. Trocar de
// aparelho ou limpar o navegador zera a lista.

const KEY = 'bruna-bia:favoritos';

const read = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // Navegação privada sem storage: o coração ainda responde na página.
  }
};

let frame = 0;

// Todo botão e contador da página lê a lista de novo: cards trocados
// pela busca ou pelos filtros nascem certos sem ninguém avisar.
function sync() {
  const list = read();
  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const active = list.includes(button.dataset.wishlistToggle);
    button.setAttribute('aria-pressed', String(active));
    const label = active ? button.dataset.labelRemove : button.dataset.labelAdd;
    if (label) button.setAttribute('aria-label', label);
  });
  document.querySelectorAll('[data-wishlist-count]').forEach((counter) => {
    counter.textContent = String(list.length);
    counter.hidden = list.length === 0;
  });
  document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list } }));
}

function scheduleSync() {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(sync);
}

function toggle(handle) {
  const list = read();
  const index = list.indexOf(handle);
  if (index >= 0) list.splice(index, 1);
  else list.unshift(handle);
  write(list);
  sync();
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-toggle]');
  if (!button) return;
  event.preventDefault();
  toggle(button.dataset.wishlistToggle);
});

// Outra aba mexeu na lista: o contador daqui acompanha.
window.addEventListener('storage', (event) => {
  if (event.key === KEY) scheduleSync();
});

// Cards que chegam depois (filtros, busca, editor de temas).
new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', scheduleSync);
sync();

class WishlistPage extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-wishlist-grid]');
    this.empty = this.querySelector('[data-wishlist-empty]');
    if (!this.grid) return;
    this.listeners = new AbortController();
    document.addEventListener('wishlist:change', this.handleChange, { signal: this.listeners.signal });
    this.render();
  }

  disconnectedCallback() {
    this.listeners?.abort();
  }

  // Tirar o coração de um card da página tira o card também.
  handleChange = ({ detail }) => {
    this.grid.querySelectorAll('[data-handle]').forEach((item) => {
      if (!detail.list.includes(item.dataset.handle)) item.remove();
    });
    this.toggleEmpty();
  };

  async render() {
    const list = read();
    const root = window.Shopify?.routes?.root || '/';
    const cards = await Promise.all(list.map(async (handle) => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}?view=card`);
        // Produto que saiu do ar não volta: some da grade sem alarde.
        if (!response.ok) return null;
        return { handle, html: await response.text() };
      } catch {
        return null;
      }
    }));
    cards.filter(Boolean).forEach(({ handle, html }) => {
      const item = document.createElement('li');
      item.className = 'wishlist__item';
      item.dataset.handle = handle;
      item.innerHTML = html;
      this.grid.append(item);
    });
    sync();
    this.toggleEmpty();
  }

  toggleEmpty() {
    const count = this.grid.children.length;
    this.grid.hidden = count === 0;
    if (this.empty) this.empty.hidden = count > 0;
  }
}

if (!customElements.get('wishlist-page')) {
  customElements.define('wishlist-page', WishlistPage);
}
